<template>
  <div>
    <b-form-group
      class="input-group-var-mes"
      label="Mes:"
      label-size="sm"
      label-for="input-var-mes"
      label-cols="4"
    >
      <b-form-select
        required
        size="sm"
        id="input-var-mes"
        class="var-mes"
        v-model="mes"
        :options="opcionsMesos"
        @input="onUpdateMes"
      >
      </b-form-select>
    </b-form-group>
  </div>
</template>

<script>
import moment from 'moment';
export default {
  name: "VariableMesos",
  props: {
    initialValue: {
      required: true,
    },
  },
  data() {
    return {
      codiVariable: "mesos",
      mes: null,
      opcionsMesos: [
        { value: "01", text: this.$t("variables.mesos.01") },
        { value: "02", text: this.$t("variables.mesos.02") },
        { value: "03", text: this.$t("variables.mesos.03") },
        { value: "04", text: this.$t("variables.mesos.04") },
        { value: "05", text: this.$t("variables.mesos.05") },
        { value: "06", text: this.$t("variables.mesos.06") },
        { value: "07", text: this.$t("variables.mesos.07") },
        { value: "08", text: this.$t("variables.mesos.08") },
        { value: "09", text: this.$t("variables.mesos.09") },
        { value: "10", text: this.$t("variables.mesos.10") },
        { value: "11", text: this.$t("variables.mesos.11") },
        { value: "12", text: this.$t("variables.mesos.12") },
      ],
    };
  },
  computed: {
    returnValue() {
      let r = { codi: this.codiVariable };
      if (this.mes != null) {
        r.valor = this.mes;
      }

      return r;
    },
  },
  methods: {
    onUpdateMes(newValue) {
      this.$emit("mes-seleccionat", newValue);
    },
  },
  mounted() {
    if (this.initialValue != null) {
      this.mes = this.initialValue.valor;
    } else{
      this.mes = moment().format("MM");
    }
  },
};
</script>

<style>
.var-mes {
  width: 180px;
}
.input-group-var-mes .col {
  text-align: left;
}
</style>
